import {Injectable, signal, WritableSignal} from '@angular/core';
import {BreadcrumbItem, BreadcrumbsComponent} from 'src/app/common/templates/breadcrumbs/breadcrumbs.component';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
    component!: BreadcrumbsComponent;
    items: WritableSignal<BreadcrumbItem[]> = signal([]);
    constructor() {

    }
    public bindComponent(component: BreadcrumbsComponent) {
        this.component = component;
        this.component?.setItems(this.items);
    }
    public setItems(items: any[]){
      this.items.set(items);
    }
    public addItems(items: BreadcrumbItem[]){
        this.items.update(el=>({...el,...items}));
    }
}
